(function () {
  'use strict';

  var STORAGE_SESSION = 'marbenio_concierge_seen';
  var STORAGE_COOLDOWN = 'marbenio_concierge_until';
  var COOLDOWN_DAYS = 5;
  var IDLE_MS = 28000;
  var MIN_PAGE_IDLE_MS = 8000;
  var MIN_PAGE_SWIPE_MS = 2500;
  var SWIPE_MIN_DELTA = 38;
  var SWIPE_MAX_MS = 650;

  var root = document.getElementById('MarbenioConcierge');
  if (!root) return;

  var formState = window.MarbenioConciergeFormState || {};
  var pageLoadedAt = Date.now();
  var hasShown = false;
  var idleTimer = null;
  var swipeStartY = 0;
  var swipeStartTime = 0;
  var swipeActive = false;

  if (formState.success) {
    root.classList.add('is-submitted');
    var successEl = root.querySelector('#MarbenioConciergeSuccess');
    if (successEl) successEl.removeAttribute('hidden');
    sessionStorage.setItem(STORAGE_SESSION, '1');
  }

  if (formState.errors) {
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    root.classList.add('is-active', 'is-visible');
    document.documentElement.classList.add('marbenio-concierge-open');
    hasShown = true;
  }

  var mobileQuery = window.matchMedia('(max-width: 749px)');
  if (!mobileQuery.matches && !formState.success && !formState.errors) return;

  if (window.location.pathname.indexOf('/checkout') === 0) return;
  if (document.body.classList.contains('template-cart')) return;

  var dismissedUntil = parseInt(localStorage.getItem(STORAGE_COOLDOWN) || '0', 10);
  if (Date.now() < dismissedUntil && !formState.success && !formState.errors) return;
  if (sessionStorage.getItem(STORAGE_SESSION) === '1' && !formState.success && !formState.errors) return;

  function isPageAtTop() {
    return (window.scrollY || document.documentElement.scrollTop || 0) <= 20;
  }

  function isBlockedUiOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) return true;
    if (document.querySelector('details.menu-drawer-container[open]')) return true;
    if (document.querySelector('.marbenio-concierge.is-visible')) return true;
    return false;
  }

  function canShowIdle() {
    if (hasShown) return false;
    if (Date.now() - pageLoadedAt < MIN_PAGE_IDLE_MS) return false;
    if (isBlockedUiOpen()) return false;
    return true;
  }

  function canShowSwipe() {
    if (hasShown) return false;
    if (Date.now() - pageLoadedAt < MIN_PAGE_SWIPE_MS) return false;
    if (isBlockedUiOpen()) return false;
    return true;
  }

  function markDismissed() {
    sessionStorage.setItem(STORAGE_SESSION, '1');
    localStorage.setItem(STORAGE_COOLDOWN, String(Date.now() + COOLDOWN_DAYS * 86400000));
  }

  function openPopup(force) {
    if (!force && !canShowIdle()) return;
    hasShown = true;
    clearTimeout(idleTimer);

    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('marbenio-concierge-open');

    requestAnimationFrame(function () {
      root.classList.add('is-active');
      requestAnimationFrame(function () {
        root.classList.add('is-visible');
      });
    });
  }

  function closePopup() {
    root.classList.remove('is-visible');
    setTimeout(function () {
      root.classList.remove('is-active');
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('marbenio-concierge-open');
    }, 560);
    markDismissed();
  }

  function resetIdleTimer() {
    if (hasShown) return;
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      if (canShowIdle()) openPopup(false);
    }, IDLE_MS);
  }

  root.querySelectorAll('[data-concierge-close]').forEach(function (el) {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener(
    'touchstart',
    function (e) {
      resetIdleTimer();
      if (!canShowSwipe() || e.touches.length !== 1) return;

      if (!isPageAtTop()) {
        swipeActive = false;
        return;
      }

      swipeStartY = e.touches[0].clientY;
      swipeStartTime = Date.now();
      swipeActive = true;
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      if (hasShown) return;

      if (swipeActive && canShowSwipe() && e.touches.length === 1 && isPageAtTop()) {
        var dy = e.touches[0].clientY - swipeStartY;
        var dt = Date.now() - swipeStartTime;

        if (dy > SWIPE_MIN_DELTA && dt < SWIPE_MAX_MS) {
          swipeActive = false;
          openPopup(true);
          return;
        }
      }

      resetIdleTimer();
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchend',
    function () {
      swipeActive = false;
    },
    { passive: true, capture: true }
  );

  document.addEventListener('scroll', resetIdleTimer, { passive: true });

  resetIdleTimer();

  var form = document.getElementById('MarbenioConciergeForm');
  if (form) {
    form.addEventListener('submit', function () {
      sessionStorage.setItem(STORAGE_SESSION, '1');
    });
  }

  if (formState.success) {
    openPopup(true);
    markDismissed();
  }
})();
